/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredients_PlaceholderInputs */

const en_editor_ingredients_placeholder = /** @type {(inputs: Editor_Ingredients_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`200 g low-fat quark
2 onions, diced

Sauce:
1 can tomatoes`)
};

const de_editor_ingredients_placeholder = /** @type {(inputs: Editor_Ingredients_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`200 g Magerquark
2 Zwiebeln, gewürfelt

Sauce:
1 Dose Tomaten`)
};

/**
* | output |
* | --- |
* | "200 g low-fat quark 2 onions, diced Sauce: 1 can tomatoes" |
*
* @param {Editor_Ingredients_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredients_placeholder = /** @type {((inputs?: Editor_Ingredients_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredients_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredients_placeholder(inputs)
	return en_editor_ingredients_placeholder(inputs)
});